import { getDynamicCurrency } from '@/util-conversion/currency/currency-to-string';
import Spacer from '@/common/components/spacer';

export interface DayOneLossCardProps {
  totalPrice: number;
  wholesalePrice: number;
  dayOneLossAmount: number;
}

export default function DayOneLossCard({
  totalPrice,
  wholesalePrice,
  dayOneLossAmount,
}: DayOneLossCardProps) {
  return (
    <div className="rounded-3xl border-[1px] bg-white px-4 py-3">
      <div className="flex justify-start">
        <p className="body2-strong flex items-center gap-1 text-flexcar-redScorsese">
          Day 1 Buying Losses: {getDynamicCurrency(dayOneLossAmount)}
        </p>
      </div>

      <Spacer variant="height6" />

      <p className="body3 font-normal">
        If you were to buy this car,{' '}
        <span className="font-semibold">
          you&apos;d instantly lose {getDynamicCurrency(dayOneLossAmount)} on Day 1
        </span>{' '}
        <span className="text-flexcar-neutral50">
          (Total purchase price {getDynamicCurrency(totalPrice)} minus Wholesale price{' '}
          {getDynamicCurrency(wholesalePrice)})
        </span>
        .
      </p>
    </div>
  );
}
